import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="bg-[#2C3C30] text-[#F7F6F2]"
      data-testid="footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <p className="font-sans text-xs tracking-[0.4em] uppercase text-[#7D8C7A] mb-6">
              Ready to heal?
            </p>
            <h2 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight">
              Your gut deserves a plan, not a guess.
            </h2>
            <Link
              to="/contact"
              data-testid="footer-book-cta"
              className="inline-flex mt-10 items-center gap-3 rounded-full bg-[#F7F6F2] px-8 py-4 text-[#2C3C30] font-medium transition-colors duration-300 hover:bg-[#D1D6CC]"
            >
              Book a Consultation
            </Link>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="font-sans text-xs tracking-[0.3em] uppercase text-[#7D8C7A] mb-6">
              Navigate
            </p>
            <ul className="space-y-3 font-sans">
              {[
                { to: "/", l: "Home" },
                { to: "/about", l: "About" },
                { to: "/services", l: "Services" },
                { to: "/blog", l: "Blog" },
                { to: "/contact", l: "Contact & Booking" },
              ].map((i) => (
                <li key={i.to}>
                  <Link
                    to={i.to}
                    className="text-[#D1D6CC] hover:text-[#F7F6F2] transition-colors duration-300"
                  >
                    {i.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-sans text-xs tracking-[0.3em] uppercase text-[#7D8C7A] mb-6">
              Contact
            </p>
            <ul className="space-y-4 font-sans text-[#D1D6CC]">
              <li className="flex items-center gap-3">
                <Mail size={16} /> helloadya4@gmail.com
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} /> +91 81082 73005
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={16} /> Mumbai, India &middot; Clinic &amp; Telehealth
              </li>
              <li className="flex items-center gap-3">
                <Instagram size={16} /> @adyanutrition
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#F7F6F2]/15 flex flex-col md:flex-row md:items-center justify-between gap-4 text-sm text-[#7D8C7A] font-sans">
          <div className="flex items-center gap-4">
            <img
              src="/logo.png"
              alt="Adya Nutrition logo"
              className="h-12 w-12 object-contain rounded-full bg-[#F7F6F2]/5"
            />
            <span>&copy; {new Date().getFullYear()} Adya Nutrition. All rights reserved.</span>
          </div>
          <span className="font-serif italic text-[#D1D6CC]">
            Evidence-based &middot; Integrative &middot; Gut-first
          </span>
        </div>
      </div>
    </footer>
  );
}
